<template>
  <b-nav-item-dropdown ref="notification-dropdown" class="dropdown-notification mr-25" menu-class="nx-dropdown" right @show="onShow">
    <template #button-content>
      <feather-icon v-bind:badge="badge" badge-classes="bg-danger" class="text-body" icon="CalendarIcon" size="21"/>
    </template>

    <!-- Header -->
    <li class="nx-dd__header nx-dd__header--events">
      <div class="nx-dd__title">
        <span class="nx-dd__icon"><feather-icon icon="CalendarIcon" size="18"/></span>
        <span>{{ $t('navDropdown.events') }}</span>
      </div>
      <b-badge pill class="nx-dd__count" v-if="events.length > 0">{{ events.length }}</b-badge>
    </li>

    <!-- Events -->
    <li class="nx-dd__list">
      <b-link v-for="event in events" :key="event.id" class="nx-item">
        <div class="nx-item__avatar">
          <b-avatar size="40" :variant="$t(`calendarTypes.${event.type}.color`)">
            <template #default><i :class="$t(`calendarTypes.${event.type}.symbol`)"/></template>
          </b-avatar>
        </div>
        <div class="nx-item__content">
          <div class="nx-item__title">{{ getEventTitle(event) }}</div>
          <div class="nx-item__time">
            <feather-icon icon="ClockIcon" size="11"/>
            {{ event.start | momentDateTime }}
          </div>
        </div>
      </b-link>

      <div v-if="!loading && events.length === 0" class="nx-empty">
        <span class="nx-empty__icon"><feather-icon icon="CalendarIcon" size="26"/></span>
        <span>{{ $t('navDropdown.noEvents') }}</span>
      </div>
      <div v-if="loading" class="nx-loading"><b-spinner small class="mr-50"/>{{ $t('operations.loading') }}</div>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import { mapActions, mapGetters } from 'vuex'
import mixinBase from '@/components/mixin/mixinBase'
import mixinTable from '@/components/mixin/mixinTable'
import { vue } from '@/main'

export default {
  name: 'CalendarEventsDropdown',
  components:{VuePerfectScrollbar},
  mixins:[ mixinBase],
  data:()=>({
    badge: '',
    events: [],
    loading: false,
  }),
  computed:{

  },
  methods:{
    ...mapActions('calendar', ['getTodayUpcomingEvents']),
    onShow(){
      this.fetchEvents();
    },
    fetchEvents() {
      let $this = this;
      this.loading = true;
      this.getTodayUpcomingEvents().then(data=>{
        $this.events = data?.sort((a,b)=>{
          return $this.$moment(a.start).unix() - $this.$moment(b.start).unix()
        });
      }).finally(()=>{
        $this.loading = false;
      })
    },
    getEventTitle(event) {
      let title = event.title || null;
      if(event.clientNames != null){
        title = Object.values(event.clientNames)[0]
        title = vue.$t(`calendarTypes.${event.type || 'EVENT'}.name`) + ' - ' + title
      }
      if(title == null || title === ''){
        title = vue.$t(`calendarTypes.${event.type}.name`)
      }
      return title;
    }

  },
}
</script>

<style>

</style>
